require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./front-end-libraries-react-pass-a-callback-as-props.json") })
        }
      }, "path---front-end-libraries-react-pass-a-callback-as-props");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---front-end-libraries-react-pass-a-callback-as-props!./.cache/json/front-end-libraries-react-pass-a-callback-as-props.json
// module id = 2084
// module chunks = 231608221292675